import { render, staticRenderFns } from "./ProductVision.vue?vue&type=template&id=04392090&scoped=true&"
import script from "./ProductVision.vue?vue&type=script&lang=js&"
export * from "./ProductVision.vue?vue&type=script&lang=js&"
import style0 from "./ProductVision.vue?vue&type=style&index=0&id=04392090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04392090",
  null
  
)

export default component.exports